import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import {
  IAddressesState,
  reducer as addressesReducer,
} from './addresses';


export const DATA_ACCESS_ADDRESSES_FEATURE_KEY = 'addresses';
export interface IAddressesFeatureState {
  addresses: IAddressesState;
}

export const reducers: ActionReducerMap<IAddressesFeatureState> = {
  addresses: addressesReducer
};

export const getAddressesFeatureState =
  createFeatureSelector<IAddressesFeatureState>(
    DATA_ACCESS_ADDRESSES_FEATURE_KEY
  );
